import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "./index.scss";
import { Provider } from "react-redux";
import store from "./store";
// Installs the shared "Loading… / No rows found" empty state on every
// react-table in the app. Imported for its side effect, once, at the entry
// point — see utils/reactTableDefaults.js.
import "./utils/reactTableDefaults";
import AllRoutes from "./allRoutes.js";
class Root extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <BrowserRouter basename={"/"}>
        <AllRoutes />
      </BrowserRouter>
    );
  }
}

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById("root"),
);
